module.exports = __webpack_public_path__ + "static/media/UnionPay.eaea13ca.svg";